import React from 'react';

export default function AddFavourite(props) {
    const heartIconStyle = {
        fill: props.favourite ? 'red' : 'currentColor',
        marginLeft: '4px',
        cursor: 'pointer',
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className='mr-2 p-1'>Add to Favourites</span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                className="bi bi-heart-fill"
                viewBox="0 0 16 16"
                style={heartIconStyle}

            >
                <path
                    fillRule="evenodd"
                    d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                />
            </svg>
        </div>
    );
}
